<div class="wrap">
    <div class="head">
        <div class="ttl">Canales</div>
        <button mat-icon-button type="button" (click)="close()" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="sub">Asignar <span class="sub-strong">{{ productName }}</span> a canales:</div>

    <div *ngIf="loading" class="state">Cargando...</div>
    <div *ngIf="!loading && channels.length === 0" class="state">No hay canales.</div>

    <div *ngIf="!loading && channels.length > 0" class="list">
        <div *ngFor="let ch of channels" class="row">
            <ui-checkbox [id]="'ch-' + ch.uuid" [disabled]="saving" [checked]="selected.has(ch.uuid!)"
                (checkedChange)="toggle(ch.uuid!, $event)">
                <span class="name">{{ ch.name }}</span>
            </ui-checkbox>
        </div>
    </div>

    <div class="actions">
        <button mat-stroked-button type="button" (click)="reset()" [disabled]="saving || !hasChanges()">
            <mat-icon>undo</mat-icon>
            Revertir
        </button>
        <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="saving || !hasChanges()">
            <mat-icon>save</mat-icon>
            Guardar
        </button>
    </div>
</div>